<div class="adf-empty-list_template">
    <ng-content select="[adf-empty-list-header]"></ng-content>
    <ng-content select="[adf-empty-list-body]"></ng-content>
    <ng-content select="[adf-empty-list-footer]"></ng-content>
    <ng-content></ng-content>
</div>